import classNames from "classnames";
import React from "react";

interface ToggleChipProps {
    id?: string;
    label: string;
    value: boolean;
    onChange?: (value: boolean) => void;
    onBlur?: () => void;
}

export const ToggleChip = ({
    id,
    label,
    value,
    onChange,
    onBlur,
}: ToggleChipProps) => {
    return (
        <button
            type="button"
            onClick={() => {
                onChange?.(!value);
                onBlur?.();
            }}
            className={classNames(
                "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1",
                "text-xs font-medium transition-all",
                "border border-transparent",
                value ? (
                    "bg-primary-100 text-primary-700 hover:bg-primary-200" +
                    " dark:bg-primary-500/20 dark:text-primary-300 dark:hover:bg-primary-500/30"
                ) : (
                    "bg-content-100 text-content-500 hover:bg-content-200" +
                    " dark:bg-content-800 dark:text-content-400 dark:hover:bg-content-700"
                )
            )}
        >
            <div className={classNames(
                "h-3.5 w-3.5 transition-transform",
                value ? (
                    "icon-[ph--check-circle-fill] text-primary-500 dark:text-primary-400"
                ) : (
                    "icon-[ph--circle] text-content-400 dark:text-content-500"
                )
            )} />
            {label}
        </button>
    );
}; 